<ng-container *ngIf="uiType == 'grid'" class="skeleton" id="skeleton">
  <ng-container *ngFor="let row of numberOfRows">
    <div class="flex-row flex-g-l mg-l-m mg-r-m">
      <ng-container *ngFor="let column of numberOfColumns">
        <div class="skeleton-view mg-b-s mg-b-l"></div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
